'use client'

import {
	Checkbox as FukkuCheckbox,
	type CheckboxProps as FukkuCheckboxProps,
} from '@fukku/checkbox/Checkbox'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ReactNode } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

export type CheckboxProps = {
	readonly name: NonNullable<FukkuCheckboxProps['name']>
	readonly id: FukkuCheckboxProps['id']
	readonly label: FukkuCheckboxProps['label']
	readonly required?: boolean
} & Partial<FukkuCheckboxProps>

export function Checkbox({
	name: controllerName,
	id,
	required = false,
	label,
	errorMessage = 'form.empty.errormessage',
	...checkboxProps
}: CheckboxProps): ReactNode {
	const { control } = useFormContext()
	const { t } = useLabels()

	return (
		<Controller
			name={controllerName}
			control={control}
			rules={{ required }}
			render={({ field: { name, onChange, value }, fieldState: { error } }) => (
				<FukkuCheckbox
					{...checkboxProps}
					checked={value}
					errorMessage={error && t(errorMessage)}
					id={id}
					label={label}
					name={name}
					onChange={onChange}
				/>
			)}
		/>
	)
}
